import {createAction} from '@reduxjs/toolkit';

export const resetAll = createAction('RESET_ALL');
